<div class="col-md-6 col-export" data-toggle="tooltip" title="">
    <div class="export-panel-widget">
        <div class="export-panel-header">{{title | locale}}</div>
        <div class="export-panel-body">
            <ng-content></ng-content>
        </div>
    </div>
</div>